import { render } from "./InventoryWarehouseView.vue?vue&type=template&id=5e01d687"
import script from "./InventoryWarehouseView.vue?vue&type=script&lang=js"
export * from "./InventoryWarehouseView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__